export default "__VITE_ASSET__DtceQ3bv__"